export class HrEmpStudyChartModel {
  EmpId: number;
  YearTitle?: number;
  MonthNo?: number;
  MonthTitle: string;
  TotalStudy: number;
}
